// extracted by mini-css-extract-plugin
module.exports = {"nextPage":"postsPage-module--nextPage--3vg3B","prevPage":"postsPage-module--prevPage--3ExJB","pageLinkContainer":"postsPage-module--pageLinkContainer--pD6Nb"};